import { RankingDTO } from '../RankingProfile/RankingInfo';
import { get } from '../../../../shared/api';
import { PagedResponseDTO, PageSearchQueryConfig } from '../../../../shared/constants';
import { generateSearchQuery } from '../../../../shared/helpers';

export const getRankingsRequest = (pageConfig: PageSearchQueryConfig = {}): Promise<PagedResponseDTO<RankingDTO[]>> => {
  const query = generateSearchQuery(pageConfig);
  return get<PagedResponseDTO<RankingDTO[]>>(`/rankings${query}`);
};
